import { render } from "./Good.vue?vue&type=template&id=7611e5de&scoped=true"
import script from "./Good.vue?vue&type=script&lang=js"
export * from "./Good.vue?vue&type=script&lang=js"

import "./Good.vue?vue&type=style&index=0&id=7611e5de&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7611e5de"]])

export default __exports__